const pluralRulesCache = new Map();
function pluralRulesFor(locale) {
    const cached = pluralRulesCache.get(locale);
    if (cached)
        return cached;
    const rules = new Intl.PluralRules(locale);
    pluralRulesCache.set(locale, rules);
    return rules;
}
/** Resolves the ICU plural category for `count` in `locale`. */
export function pluralCategory(locale, count) {
    return pluralRulesFor(locale).select(count);
}
/** Builds a dotted translation key for a plural base key and category. */
export function pluralKey(base, category) {
    return `${base}.${category}`;
}
//# sourceMappingURL=plural.js.map